import script from "./FaqManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqManagement.vue?vue&type=script&setup=true&lang=js"

import "./FaqManagement.vue?vue&type=style&index=0&id=7dbf40be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dbf40be"]])

export default __exports__